import { Converter } from '../types/converter';

export const dataTransferConverter: Converter = {
  id: 'dataTransfer',
  name: 'Data Transfer Converter',
  icon: 'Network',
  categories: ['other'],
  units: [
    // Basic units
    { name: 'Bit/second', symbol: 'b/s', factor: 1 },
    { name: 'Byte/second', symbol: 'B/s', factor: 8 },
    
    // SI prefixed units (1000-based)
    { name: 'Kilobit/second (SI)', symbol: 'kbit/s', factor: 1000 },
    { name: 'Kilobyte/second (SI)', symbol: 'kB₁₀/s', factor: 8000 },
    { name: 'Megabit/second (SI)', symbol: 'Mbit/s', factor: 1e6 },
    { name: 'Megabyte/second (SI)', symbol: 'MB₁₀/s', factor: 8e6 },
    { name: 'Gigabit/second (SI)', symbol: 'Gbit/s', factor: 1e9 },
    { name: 'Gigabyte/second (SI)', symbol: 'GB₁₀/s', factor: 8e9 },
    { name: 'Terabit/second (SI)', symbol: 'Tbit/s', factor: 1e12 },
    { name: 'Terabyte/second (SI)', symbol: 'TB₁₀/s', factor: 8e12 },
    
    // Binary prefixed units (1024-based)
    { name: 'Kibibit/second', symbol: 'Kib/s', factor: 1024 },
    { name: 'Kibibyte/second', symbol: 'KiB/s', factor: 8192 },
    { name: 'Mebibit/second', symbol: 'Mib/s', factor: 1048576 },
    { name: 'Mebibyte/second', symbol: 'MiB/s', factor: 8388608 },
    { name: 'Gibibit/second', symbol: 'Gib/s', factor: 1073741824 },
    { name: 'Gibibyte/second', symbol: 'GiB/s', factor: 8589934592 },
    { name: 'Tebibit/second', symbol: 'Tib/s', factor: 1099511627776 },
    { name: 'Tebibyte/second', symbol: 'TiB/s', factor: 8796093022208 },
    
    // Network standards
    { name: 'Ethernet (10BASE-T)', symbol: 'Ethernet-10', factor: 10000000 },
    { name: 'Fast Ethernet (100BASE-T)', symbol: 'Ethernet-100', factor: 100000000 },
    { name: 'Gigabit Ethernet (1000BASE-T)', symbol: 'Ethernet-1000', factor: 1000000000 },
    
    // Optical Carrier levels
    { name: 'OC-1', symbol: 'OC-1', factor: 51840000 },
    { name: 'OC-3', symbol: 'OC-3', factor: 155520000 },
    { name: 'OC-12', symbol: 'OC-12', factor: 622080000 },
    { name: 'OC-24', symbol: 'OC-24', factor: 1244160000 },
    { name: 'OC-48', symbol: 'OC-48', factor: 2488320000 },
    { name: 'OC-192', symbol: 'OC-192', factor: 9953280000 },
    { name: 'OC-768', symbol: 'OC-768', factor: 39813120000 },
    
    // ISDN
    { name: 'ISDN (single channel)', symbol: 'ISDN-1B', factor: 64000 },
    { name: 'ISDN (dual channel)', symbol: 'ISDN-2B', factor: 128000 },
    
    // Modems
    { name: 'Modem 110 baud', symbol: 'V.21-110', factor: 110 },
    { name: 'Modem 300 baud', symbol: 'V.21-300', factor: 300 },
    { name: 'Modem 1200 baud', symbol: 'V.22-1200', factor: 1200 },
    { name: 'Modem 2400 baud', symbol: 'V.22bis-2400', factor: 2400 },
    { name: 'Modem 9600 baud', symbol: 'V.32-9600', factor: 9600 },
    { name: 'Modem 14.4k', symbol: 'V.32bis-14.4k', factor: 14400 },
    { name: 'Modem 28.8k', symbol: 'V.34-28.8k', factor: 28800 },
    { name: 'Modem 33.6k', symbol: 'V.34-33.6k', factor: 33600 },
    { name: 'Modem 56k', symbol: 'V.90-56k', factor: 56000 },
    
    // SCSI
    { name: 'SCSI Async', symbol: 'SCSI-1-Async', factor: 5000000 },
    { name: 'SCSI Sync', symbol: 'SCSI-1-Sync', factor: 10000000 },
    { name: 'SCSI Fast', symbol: 'SCSI-2-Fast', factor: 20000000 },
    { name: 'SCSI Fast Ultra', symbol: 'SCSI-3-Fast-Ultra', factor: 40000000 },
    { name: 'SCSI Fast Wide', symbol: 'SCSI-2-Fast-Wide', factor: 40000000 },
    { name: 'SCSI Fast Ultra Wide', symbol: 'SCSI-3-Fast-Ultra-Wide', factor: 80000000 },
    { name: 'SCSI Ultra-2', symbol: 'SCSI-Ultra-2', factor: 80000000 },
    { name: 'SCSI Ultra-3', symbol: 'SCSI-Ultra-3', factor: 160000000 },
    { name: 'SCSI LVD Ultra80', symbol: 'SCSI-LVD-Ultra80', factor: 80000000 },
    { name: 'SCSI LVD Ultra160', symbol: 'SCSI-LVD-Ultra160', factor: 160000000 },
    
    // IDE/ATA
    { name: 'IDE PIO Mode 0', symbol: 'PIO-0', factor: 3300000 },
    { name: 'IDE PIO Mode 1', symbol: 'PIO-1', factor: 5200000 },
    { name: 'IDE PIO Mode 2', symbol: 'PIO-2', factor: 8300000 },
    { name: 'IDE PIO Mode 3', symbol: 'PIO-3', factor: 11100000 },
    { name: 'IDE PIO Mode 4', symbol: 'PIO-4', factor: 16600000 },
    { name: 'IDE DMA Mode 0', symbol: 'DMA-0', factor: 4200000 },
    { name: 'IDE DMA Mode 1', symbol: 'DMA-1', factor: 13300000 },
    { name: 'IDE DMA Mode 2', symbol: 'DMA-2', factor: 16600000 },
    { name: 'IDE UDMA Mode 0', symbol: 'UDMA-0', factor: 16600000 },
    { name: 'IDE UDMA Mode 1', symbol: 'UDMA-1', factor: 25000000 },
    { name: 'IDE UDMA Mode 2', symbol: 'UDMA-2', factor: 33300000 },
    { name: 'IDE UDMA Mode 3', symbol: 'UDMA-33', factor: 44400000 },
    { name: 'IDE UDMA Mode 4', symbol: 'UDMA-66', factor: 66600000 },
    
    // Other interfaces
    { name: 'USB 1.1 (Full Speed)', symbol: 'USB-1.1', factor: 12000000 },
    { name: 'FireWire 400', symbol: 'FireWire-400', factor: 400000000 },
    
    // T-carrier systems
    { name: 'T0 Payload', symbol: 'T0-56K', factor: 56000 },
    { name: 'T0 B8ZS Payload', symbol: 'T0-64K', factor: 64000 },
    { name: 'T1 Signal', symbol: 'T1-1.544M', factor: 1544000 },
    { name: 'T1 Payload', symbol: 'T1-1.536M', factor: 1536000 },
    { name: 'T1Z Payload', symbol: 'T1Z-1.544M', factor: 1544000 },
    { name: 'T1C Signal', symbol: 'T1C-3.152M', factor: 3152000 },
    { name: 'T1C Payload', symbol: 'T1C-3.072M', factor: 3072000 },
    { name: 'T2 Signal', symbol: 'T2-6.312M', factor: 6312000 },
    { name: 'T3 Signal', symbol: 'T3-44.736M', factor: 44736000 },
    { name: 'T3 Payload', symbol: 'T3-44.21M', factor: 44210000 }
  ]
};
